// extracted by mini-css-extract-plugin
module.exports = {"resourcesGrid":"everything-you-need-section_resourcesGrid__P53QV"};